var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "16", height: "16", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.656 7.438l-5.75 8.406c-.104.146-.24.187-.406.125-.167-.063-.24-.177-.219-.344l.438-5.906-2.688-.25a.554.554 0 0 1-.484-.328.553.553 0 0 1 .047-.579L9.344.156c.104-.146.24-.187.406-.125.167.063.24.177.219.344L9.53 6.281l2.688.25c.229.021.39.13.484.328a.553.553 0 0 1-.047.579z", fill: "#FFF" })
  );
});


// WEBPACK FOOTER //
// ./src/shared/components/NavBar/icons/BoostBolt.svg